// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { spinner } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-spinner': IconSpinner;
    }
}

/**
 * The icon component for the 'spinner' icon
 */
export class IconSpinner extends Icon {
    public constructor() {
        super(spinner);
    }
}

registerIcon('icon-spinner', IconSpinner);
export const iconSpinnerTag = 'nimble-icon-spinner';
